import { useRef } from "react"
import { motion } from "framer-motion"
import { useFollowPointer } from "../hooks/useFollowPointer"
import useGlobalContext from "../context/GlobalContext"

const Cursor = () => {
  const cursorRef = useRef(null)
  const { cursorType } = useGlobalContext()

  const { x, y } = useFollowPointer(cursorRef)

  return (
    <motion.div
      ref={cursorRef}
      className={`custom-cursor ${cursorType ? cursorType : ""}`}
      animate={{ x, y }}
    >
      {cursorType === "drag" || cursorType === "dragging" ? "Drag" : null}
    </motion.div>
  )
}

export default Cursor
